import { Language } from '../enums';
import { mapLanguageIso2ToLanguageNameAR, mapLanguageIso2ToLanguageNameEN } from './map-language-iso-2-to-language-name';
import { mapLanguageISO3To2 } from './map-language-iso-3-to-2';

const ISO_3_COUNTRY_CODE_LENGTH = 3;

export const mapLanguageISOToLanguageName = (languageIsoCode: string, lang: string = Language.EN): string => {
  const iso2LanguageCode = languageIsoCode.length === ISO_3_COUNTRY_CODE_LENGTH ? mapLanguageISO3To2[languageIsoCode] : languageIsoCode;
  return lang === Language.EN ? mapLanguageIso2ToLanguageNameEN[iso2LanguageCode] : mapLanguageIso2ToLanguageNameAR[iso2LanguageCode];
};
